if (typeof document !== 'undefined' && !document.head.querySelector("style[data-wp-hash='8772a8ae3a']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "8772a8ae3a");
	style.appendChild(document.createTextNode(".boot-sidebar__scrollable{display:flex;flex-direction:column;height:100%;overflow:auto;position:relative}.boot-sidebar__content{contain:content;flex-grow:1;position:relative}.boot-sidebar__footer{padding:16px 8px 8px 16px}"));
	document.head.appendChild(style);
}
